// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"GP-z","categoryName":"HP-z","categoryNameSearchHeader":"IP-z","categoryContent":"JP-z","bottomAligned":"KP-z","image":"LP-z","imageNoBackground":"MP-z"};